module.exports = __webpack_public_path__ + "static/media/Phone.15aa8af0.svg";